import DirectionsCol from './directions-col'

export default DirectionsCol
